import {useLocation, useNavigate} from 'react-router-dom';
import {BIOMETRIC_STEPS} from '../constants/biometric-steps';
import {useCurrentStepStore} from '../store';

export function useBiometricWizard() {
	const navigate = useNavigate();
	const {currentStep, setStep} = useCurrentStepStore();
	const location = useLocation();

	function goToStep(step: number) {
		setStep(step);
		navigate({pathname: BIOMETRIC_STEPS[step], search: location.search});
	}

	function next() {
		const nextStep = currentStep + 1;
		if (nextStep >= BIOMETRIC_STEPS.length) return;
		goToStep(nextStep);
	}

	function prev() {
		const prevStep = currentStep - 1;
		if (prevStep < 0) return;
		goToStep(prevStep);
	}

	return {
		currentStep,
		next,
		prev,
		goToStep,
	};
}
